import { useEffect, useState } from "react";
import { useAuth } from "src/context/AuthProvider";
import { isDemoMode } from "src/demo/demoApi";
import { fetchCurrentAppVersion, hasSeenChangelog, markChangelogSeen } from "src/services/appVersion";
import { isStandard } from "src/utils/roles";
import WhatsNewPopup from "./WhatsNewPopup";

/**
 * Opens What's New once per published version and browser, for people who weren't in an open tab
 * when it was published (those get UpdateBanner). Waits for the first-login and trial-end dialogs,
 * and a practice registered after the release has nothing new to read, so it's only marked seen.
 */
export default function WhatsNewOnLogin() {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);

    const onboarding = !!user && !user.doctor.avvSignedAt && !isStandard(user.doctor.userRights);
    const trialEnding = user?.praxis?.subscriptionStatus === "pending_acceptance";
    const ready = !!user && !onboarding && !trialEnding && !isDemoMode();
    const praxisCreatedAt = user?.praxis?.createdAt;

    useEffect(() => {
        if (!ready) return;
        let cancelled = false;
        fetchCurrentAppVersion().then((v) => {
            if (cancelled || !v || hasSeenChangelog(v.version)) return;
            if (praxisCreatedAt && new Date(praxisCreatedAt) >= new Date(v.publishedAt)) {
                markChangelogSeen(v.version);
                return;
            }
            setOpen(true);
        }).catch(() => {});
        return () => { cancelled = true; };
    }, [ready, praxisCreatedAt]);

    return open ? <WhatsNewPopup onClose={() => setOpen(false)} /> : null;
}
